import { render, staticRenderFns } from "./ProductsCategories.vue?vue&type=template&id=6c8a1386"
import script from "./ProductsCategories.vue?vue&type=script&lang=js"
export * from "./ProductsCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports